<template>
  <div id="app">
    <component
      :is="layoutComponent"
      v-bind="layoutProps"
      @created="layoutCreated"
      id="appLayoutContainer"
    >
      <router-view />
    </component>
    <div
      v-if="this.$route.name == 'Dashboard' && !offline"
      id="snackbar"
      :class="this.$store.state.loadPwa == 1 ? 'show' : 'hide'"
    >
      <div class="pwa-loading-msg">
        <spinner></spinner>
        <span>Daten werden heruntergeladen...</span>
      </div>
    </div>
    <div
      v-if="this.$route.name == 'Dashboard' && !offline"
      id="snackbar"
      class="downloadedPwaData"
      :class="this.$store.state.loadPwa == 2 ? 'show' : 'hide'"
    >
      <div class="pwa-loading-msg">
        <img :src="icon('light-check.svg')" alt="" />
        <span>Daten vollständig heruntergeladen.</span>
      </div>
    </div>
    <div id="alerts"></div>

    <connectivity-badge
      :connection-check-running="connectionCheckRunning"
    ></connectivity-badge>

    <div id="layers">
      <div class="layer--loading" v-if="isLoading && !offline">
        <spinner></spinner>
      </div>
      <div class="layer--connection-needed layer--dark" v-if="connectionNeeded">
        <div>
          <p class="h2">{{ __("main.common.messages.connection_needed") }}</p>
          <p class="h5 text-medium">
            {{ __("main.common.messages.connection_waiting") }}
          </p>

          <spinner class="d-inline-block mt-md"></spinner>
        </div>
      </div>
    </div>
    <div class="iframe img-icons-load">
      <template v-for="(item, index) in files_url">
        <iframe
          v-bind:key="index"
          :src="item"
          frameborder="0"
          class="documnet-preview img-icons-load"
        ></iframe>
      </template>
      <!-- <div class="files" v-if="files_url.length > 0">
        <vue-pdf-app :pdf="files_url[0]"></vue-pdf-app>
      </div> -->
    </div>
    <div class="img-icons-load" v-html="loadIcons"></div>
  </div>
</template>

<script>
import LayoutApp from "./layouts/App";
import { mapState } from "vuex";
// import VuePdfApp from "smartdoors-shared/node_modules/vue-pdf-app";
// import this to use default icons for buttons
// import "smartdoors-shared/node_modules/vue-pdf-app/dist/icons/main.css";

export default {
  provide() {
    return {
      iconSource: this.icon,
    };
  },
  components: {
    // VuePdfApp,
  },
  data() {
    return {
      needsConnection: false,
      isLoading: false,
      connectionCheckRunning: false,
      checkingConnection: null,
      layout: null,
      loadingPwa: null,
    };
  },
  created() {
    let app = this;

    Vue.mixin({
      data() {
        return {
          app: app,
        };
      },
    });

    window.addEventListener("online", () => {
      this.checkConnection();
    });
    window.addEventListener("offline", () => {
      this.checkConnection();
    });

    this.checkConnection(true);
  },

  computed: {
    files_url() {
      return this.$store.getters["jobs/file_urls"];
    },
    ...mapState(["offline"]),
    connectionNeeded() {
      return (
        this.routeMeta &&
        "needsConnection" in this.routeMeta &&
        this.routeMeta.needsConnection &&
        this.offline
      );
    },
    routeMeta() {
      return this.$store.state.navigation.currentRoute &&
        "meta" in this.$store.state.navigation.currentRoute
        ? this.$store.state.navigation.currentRoute.meta
        : null;
    },
    layoutComponent() {
      return this.routeMeta && "layout" in this.routeMeta
        ? this.routeMeta.layout
        : LayoutApp;
    },
    layoutProps() {
      return {
        title:
          this.routeMeta && "title" in this.routeMeta
            ? this.routeMeta.title
            : "",
      };
    },
    loadIcons() {
      /**
       * Icons
       */
      const icons = require.context("smartdoors-shared/img/icons", true);
      let htmlIcons =
        '<img src="/img/job/door-transparent.png" /> <img src="/img/job/suva.svg" /><img src="/img/job/door.png" />';
      icons.keys().forEach((filePath) => {
        const component = icons(filePath);

        // Dynamically register the component.
        htmlIcons = htmlIcons + '<img src="' + component + '" />';
      });
      return htmlIcons;
    },

    ...mapState(["offline", "options"]),
  },
  watch: {
    offline(isOnline, wasOffline) {
      if (isOnline == false && wasOffline == true) {
        this.$store.dispatch("jobs/load", {
          path: "jobs?join=manager.profile,contacts,tools,skills,parts.fittings,parts.report,parts.codes&",
          params: {},
          sources: ["api"], // if this is a reload, we don't want to fetch from the api since a (by the store triggered) reload means that the new data is already within the store
          disableLoadDocs: true,
        }).then((res) => {
          // location.reload()
        }).catch(err =>{
          console.log(err)
        })
      }
    },
  },
  methods: {
    layoutCreated(layout) {
      this.layout = layout;
    },

    checkConnection(forceApiCheck = false) {
      if (navigator.onLine && (forceApiCheck || this.$store.state.offline)) {
        if (this.connectionCheckRunning) {
          return false;
        }

        this.connectionCheckRunning = !forceApiCheck;

        this.checkingConnection = this.$store.dispatch("checkConnection");
        this.checkingConnection.finally(() => {
          this.connectionCheckRunning = false;
          this.checkingConnection = null;
        });
      } else {
        this.$store.commit("setOffline", !navigator.onLine);
      }
    },
  },
};
</script>

<style lang="scss">
@import "sass/app";
#snackbar {
  visibility: hidden;
  min-width: 250px;
  background-color: #000;
  color: #fff;
  padding: 0;
  position: fixed;
  z-index: 10;
  left: 1rem;
  bottom: 1rem;
  animation: all 0.5s;
}

#snackbar.show {
  visibility: visible;
  //   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}
#snackbar.hide {
  //   -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  -webkit-animation: fadeout 0.5s 2.5s;
  animation: fadeout 0.5s 2.5s;
  visibility: hidden;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
.pwa-loading-msg {
  display: flex;
  align-items: center;
  z-index: 99999;
  .spinner {
    transform: scale(0.4);
    animation: none;
  }
}
.downloadedPwaData {
  padding: 1rem !important;
  .pwa-loading-msg {
    img {
      width: 32px;
      height: auto;
      margin-right: 10px;
    }
  }
}
.img-icons-load {
  display: block;
  overflow: hidden;
  height: 0px;
  overflow: hidden;
}
</style>
